import React from "react";

const MoveAppointmentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="move_appointment_icon"
      data-name="move appointment"
      {...props}
      width={props.width || "18"}
      height={props.height || "18"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.25 7.5H8.25V10.5H5.25V7.5ZM5.25 3H8.25V6H5.25V3ZM5.25 12H8.25V15H5.25V12ZM9.75 7.5H12.75V10.5H9.75V7.5ZM9.75 3H12.75V6H9.75V3ZM9.75 12H12.75V15H9.75V12Z" fill="#B9CED5"/>
    </svg>
  );
};

export default MoveAppointmentIcon;
